import React from 'react';
import Layout from '../components/Layout';

const About = () => {
  return (
    <Layout>
      <h2>Giới thiệu</h2>
      <p>Chào mừng bạn đến với trang Giới thiệu!</p>
    </Layout>
  );
};

export default About;
